if(!customElements.get('component-carousel')) {
  class ComponentCarousel extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = this.querySelector('.keen-slider');
      this.slides = this.querySelectorAll('.keen-slider-slide');
      this.pageInfo = this.querySelector('.keen-slider-page');

      this.carouselMode = this.dataset.carouselMode;
      this.carouselAutoplay = this.dataset.carouselAutoplay;
      this.carouselAutomove = parseFloat(this.dataset.carouselAutomove);
      this.carouselLoopDesktop = this.dataset.carouselLoopDesktop;
      this.carouselLoopMobile = this.dataset.carouselLoopMobile;
      this.carouselCenteredDesktop = this.dataset.carouselCenteredDesktop;
      this.carouselCenteredMobile = this.dataset.carouselCenteredMobile;
      this.carouselSpacingDesktop = this.dataset.carouselSpacingDesktop;
      this.carouselSpacingTablet = this.dataset.carouselSpacingTablet;
      this.carouselSpacingMobile = this.dataset.carouselSpacingMobile;
      this.slidesScrollMode = this.dataset.slidesScrollMode;
      this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
      this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
      this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;
      this.expandableContent = this.dataset.expandableContent;

      this.resizeEventAfterInit = this.dataset.resizeEventAfterInit;
      
      
      if (this.dataset.initOndemand!='true') {
        setTimeout(()=>{ //The timeout is for the customizer
          this.initSlider();
        }, 1);
      }

      if (this.dataset.rebuildOnResize == 'true'){
        this.isLarge = $s.media.isLarge;
        window.addEventListener('resize', () => {
          if(this.sliderObj && this.isLarge != $s.media.isLarge ){
            this.sliderObj.destroy();
            this.initialized = false;
            this.initSlider();
            this.isLarge = $s.media.isLarge;     
          }       
        });
      }

    }
    
    refresh() {
      this.sliderElement = this.querySelector('.keen-slider');
      this.slides = this.querySelectorAll('.keen-slider-slide');
      this.pageInfo = this.querySelector('.keen-slider-page');
    }

    initSlider() {
      if(this.slides.length > 0 && !this.initialized) {
        this.initialized = true;
        var config = {
          mode: this.carouselMode,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          autoplay: this.carouselAutoplay,
          automove: this.carouselAutomove,
          pauseOnHover: true,
          pageInfo: this.pageInfo,
          slideChanged: (keen)=>{
            if(this.expandableContent == "true"){
              if(this.lastExpanded)
                $s.collapse(this.lastExpanded, null, 600, 'ease-in');
              var slides = keen.slides();
              var cSlide = keen.currentSlide();
              var elementToExpand = cSlide.querySelector('.slide-expand');
              $s.expand(elementToExpand, null, 400);
              this.lastExpanded = elementToExpand;

              if(slides.length < 2)
                return;
              
              if(this.previousSlide)
                this.previousSlide.classList.remove('prev');
              if(this.nextSlide)
                this.nextSlide.classList.remove('next');

              var activeIndex = slides.indexOf(keen.currentSlide());

              if(activeIndex == 0){
                this.previousSlide = slides[slides.length - 1];
              }
              else{
                this.previousSlide = slides[activeIndex - 1];
              }
              if(activeIndex == slides.length - 1){
                this.nextSlide = slides[0];
              }
              else{
                this.nextSlide = slides[activeIndex + 1];

              }

              this.previousSlide.classList.add('prev');
              this.nextSlide.classList.add('next');

                
            }                       
          },
          breakpoints: {
            '(min-width: 66.001em)': {
              loop: this.carouselLoopDesktop=="true",
              centered: this.carouselCenteredDesktop=="true",
              spacing: window?.notCenter ? "30" : this.carouselSpacingDesktop,
              slidesPerView: this.slidesPerViewDesktop,
              slidesToScroll: this.slidesScrollMode=='slide' ? 1 : Math.floor(this.slidesPerViewDesktop)
            },
            '(min-width: 38.001em) and (max-width: 66em)': {
              loop: this.carouselLoopMobile=="true",
              centered: this.carouselCenteredMobile=="true",
              spacing: this.carouselSpacingTablet,
              slidesPerView: this.slidesPerViewTablet,
              slidesToScroll: this.slidesScrollMode=='slide' ? 1 : Math.floor(this.slidesPerViewTablet)
            },
            '(max-width: 38em)': {
              loop: this.carouselLoopMobile=="true",
              centered: window?.notCenter ? false : this.carouselCenteredMobile=="true",
              spacing: this.carouselSpacingMobile,
              slidesPerView: this.slidesPerViewMobile,
              slidesToScroll: this.slidesScrollMode=='slide' ? 1 : Math.floor(this.slidesPerViewMobile)
            }
          }
        }
        var dots = this.querySelector('.keen-dots');
        if (dots) {
          config = {...config, dots: dots};
        } else {
          var bar = this.querySelector('.keen-nav-bar');
          config = {...config, navBar: bar, rubberband: false};
        }
        this.sliderObj = new KeenSlider(this.sliderElement, config);
  
        var matchHeightSelectors = this.dataset.matchHeightSelectors;
        if (matchHeightSelectors) {
          var layoutTId = 0;
          var slider = this.sliderElement;
          function layout() {
            clearTimeout(layoutTId);
            layoutTId = setTimeout(function() {
              var selectors = matchHeightSelectors.split(',');
              selectors.forEach(selector=> {
                $s.matchHeight(slider.querySelectorAll(selector));
              });
            }, 10);
          }
          $s.resizeWidthHandle(layout);
        }

        if(Shopify.designMode) {
          this.addEventListener('shopify:block:select', (e)=>{
            let index = Array.from(this.slides).findIndex(x=>x==e.target);
            if(index>=0) {
              setTimeout(()=>{
                this.sliderObj.moveToSlideRelative(index, true, 0)
              }, 10);
            }
          });
        }

        if(this.resizeEventAfterInit == "true")
          window.dispatchEvent(new Event('resize'));
      }
    }

    removeSlider() {
      this.sliderObj.destroy();
      this.initialized = false;
    }

  }
  customElements.define('component-carousel', ComponentCarousel);
}